<div
  *ngIf='componentReady'
  [formGroup]='inputForm'
  class='EditUserDetailsDialog container'>
  <div class='row'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>Email</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='email' placeholder='Email' type='email'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>First Name</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='first_name'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>Last Name</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='last_name' placeholder='Last Name'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>Company</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='company' placeholder='company'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>Address 1</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='address1' placeholder='Address 1'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>Address 2</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='address2' placeholder='Address 2'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>City</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='city' placeholder='City'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>Zip code</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='zip' placeholder='Zip' type='zip'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>Phone number</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='phone_number' placeholder='Phone number'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-9 offset-3'>
      <div class='form-group'>
        <app-select
          [items]='states'
          formControlName='state'
          label='State'></app-select>
      </div>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-9 offset-3'>
      <div class='form-group'>
        <app-select
          (selection)='onCountrySelect($event)'
          [items]='countries'
          formControlName='country'
          label='Country'></app-select>
      </div>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-12 col-sm-3 d-flex align-items-center'>
      <mat-label>Class of Service</mat-label>
    </div>
    <div class='col col-12 col-sm-9'>
      <app-select [items]='tagItems' formControlName='cos' label='CoS'></app-select>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-12 col-sm-3 d-flex align-items-center'>
      <mat-label>Franchise Number</mat-label>
    </div>
    <div class='col col-12 col-sm-9'>
      <app-text-field formControlName='franchis_number' placeholder='Franchise Number"'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-12 col-sm-3 d-flex align-items-center'>
      <mat-label>Account Note</mat-label>
    </div>
    <div class='col col-12 col-sm-9'>
      <app-text-field formControlName='account_note' placeholder='Account Note'></app-text-field>
    </div>
    </div>
  <div class='row mt-3'>
    <div class='col col-12 col-sm-3 d-flex align-items-center'>
      <mat-label>Invoice Note</mat-label>
    </div>
    <div class='col col-12 col-sm-9'>
      <app-text-field formControlName='invoice_note' placeholder='Invoice Note'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-12 col-sm-3 d-flex align-items-center'>
      <mat-label>Optional Note 1</mat-label>
    </div>
    <div class='col col-12 col-sm-9'>
      <app-text-field formControlName='optional_note_1' placeholder='Optional Note 1'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-12 col-sm-3 d-flex align-items-center'>
      <mat-label>Optional Note 2</mat-label>
    </div>
    <div class='col col-12 col-sm-9'>
      <app-text-field formControlName='optional_note_2' placeholder='Optional Note 2'></app-text-field>
    </div>
  </div>
  <div class="row mt-3" *ngIf="accountData?.user_type === 'manager'">
    <div class="col col-12 col-sm-3 d-flex align-items-center">
      <mat-label>Check for Duplicates</mat-label>
    </div>
    <div class="col col-12 col-sm-9 d-flex align-items-center">
      <span class="me-1">Disable</span><mat-slide-toggle formControlName="check_duplicate"></mat-slide-toggle><span class="ms-1">Enable</span><fa-icon
          class="ms-5 check_for_duplicate_icon"
          [icon]='iconQuestionCircle'
          [popoverAnimation]='true'
          [popoverDisabled]='false'
          [popoverOnHover]='true'
          [popoverPlacement]="'right'"
          [popover]='duplicateTooltip'
          size='1x'></fa-icon>
    </div>
  </div>
</div>